import ToggleSlider from './ToggleSlider';

export default ToggleSlider;
